import { injectable, injectFromBase } from 'inversify'
import Progress from '@/data/models/Progress'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'

@injectable()
@injectFromBase()
@RepoSettings<Endpoint>({
  model: Progress,
})
export default class ProgressRepository extends OrmApiRepository<Progress> {}
